import { Profile } from '@types';
import React from 'react';

const ProfileContext = React.createContext<Profile | null>(null);

export { ProfileContext };